// extracted by mini-css-extract-plugin
export default {"fabContainer":"fabContainer-ca1T7","fabItem":"fabItem-FYM6j","fabToggle":"fabToggle-JC77k","open":"open-SSISX"};